export const nftContractAddress = "0x80333579F03469732894eC602787456B3f370b31"